import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Card, CardHeader, CardBody, FormGroup, Label } from 'reactstrap';
import { CharacterLimitedTextarea } from './CharacterLimitedTextarea/CharacterLimitedTextarea';

export const SystemMessageCard = (props: any): JSX.Element => {
  const { handleChange, systemMaintenance, setFieldValue, systemMessageOn } = props;
  const [radioOn, setRadioOn] = useState(systemMaintenance?.showSystemMaintenanceMessage);

  const handleRadioChange = (value: any) => {
    const isOn = value === 'on';
    setRadioOn(isOn);
    setFieldValue('systemMaintenance.showSystemMaintenanceMessage', isOn);
  };

  return (
    <div>
      <Card className="mb-3">
        <CardHeader tag="h5">System Maintenance Messaging</CardHeader>
        <CardBody>
          <div
            className="d-flex align-items-center py-2 px-3 mb-3"
            style={
              systemMessageOn
                ? {
                    border: '1px solid #42A262',
                    borderRadius: '4px',
                    backgroundColor: '#ECF6EF',
                    maxWidth: '400px',
                  }
                : {
                    border: '1px solid #D0342C',
                    borderRadius: '4px',
                    backgroundColor: '#FAEBEA',
                    maxWidth: '400px',
                  }
            }
          >
            <FontAwesomeIcon
              icon={systemMessageOn ? faCheckCircle : faInfoCircle}
              className="mr-2"
              style={{ color: systemMessageOn ? '#42A262' : '#D0342C' }}
            />
            Message {systemMessageOn ? 'enabled' : 'disabled'}.
          </div>

          <FormGroup style={{ maxWidth: '400px' }}>
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label className="d-flex align-items-center">
                <input
                  type="radio"
                  name="system-maintenance-radio"
                  value="on"
                  checked={radioOn}
                  onChange={(e) => handleRadioChange(e.target.value)}
                />
                <span className={`ml-2 ${radioOn ? 'font-weight-bold' : ''}`}>Message On</span>
              </label>
              <label className="d-flex align-items-center">
                <input
                  type="radio"
                  name="system-maintenance-radio"
                  value="off"
                  checked={!radioOn}
                  onChange={(e) => handleRadioChange(e.target.value)}
                />
                <span className={`ml-2 ${!radioOn ? 'font-weight-bold' : ''}`}>Message Off</span>
              </label>
            </div>
            <Label for="system-message" className="font-weight-bold d-block">
              Message
            </Label>
            <CharacterLimitedTextarea
              rows={4}
              maxLength={150}
              name="systemMaintenance.systemMaintenanceMessage"
              onChange={handleChange}
              value={systemMaintenance?.systemMaintenanceMessage}
            />
          </FormGroup>
          <div
            className="d-flex align-items-center py-2 px-3"
            style={{
              border: '1px solid #0072B7',
              borderRadius: '4px',
              backgroundColor: '#F5F9FC',
              width: 'fit-content',
            }}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="mr-2" style={{ color: '#0072B7' }} />
            This message will apply across all shards, regardless of which shard is being edited.
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
